export const DASHLANE = {
  modalName: 'dashlaneModal',
};

export const REDEEM_LINK = 'https://www.dashlane.com/redeem';
export const FEATURES_LINK = 'https://www.dashlane.com/features';
